import { handleActions, Reducer } from "redux-actions"
import {
   ACTION_SAVEDETECTORINFO_SUCCESS
} from '../actions/detector'

export interface detectorState {
    saveStatus: boolean
}

const defualtState: detectorState = {
    saveStatus: false,
}

function handleActionSaveDetectorInfoSuccess(state: detectorState, action: any): detectorState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        saveStatus: action.payload.saveStatus
    }
} 

export const detectorReducer: Reducer<detectorState, any> = handleActions(
    {
        [ACTION_SAVEDETECTORINFO_SUCCESS]: handleActionSaveDetectorInfoSuccess
    },
    defualtState
)